import { Auth0Provider } from '@auth0/auth0-react';

/**
 * Thin wrapper around Auth0Provider that normalises configuration.
 * Used by standalone apps and the Core Shell.
 *
 * Must be rendered inside a React Router <BrowserRouter> so that
 * onRedirectCallback can receive the navigate function via useNavigate.
 *
 * @param {object}   props
 * @param {string}   props.domain               - Auth0 domain
 * @param {string}   props.clientId             - Auth0 client ID
 * @param {string}   props.audience             - Auth0 API audience
 * @param {string}   props.redirectUri          - Callback URL after login
 * @param {Function} props.onRedirectCallback   - Called after code exchange to navigate
 * @param {React.ReactNode} props.children
 */
const AuthProvider = ({ domain, clientId, audience, redirectUri, onRedirectCallback, children }) => {
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri || window.location.origin,
        audience,
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
